const HELP_DOCS_BASE_URL = 'https://www.liquidweb.com';

export default HELP_DOCS_BASE_URL;
